import { Action, createReducer, on } from '@ngrx/store';
import { commonQuestionActions } from './question.action';
import { CommonQuestionState, commonQuestionIS } from './question.state';

const commonQuestionRegister = createReducer(
  commonQuestionIS,

  on(
    commonQuestionActions.setAdminResultAction,
    (state, { result: adminResult }) => ({
      ...state,
      adminResult,
    })
  ),

  on(
    commonQuestionActions.setConsultTopQuestionsAction,
    (state, { topQuestions: consultTopQuestions }) => ({
      ...state,
      consultTopQuestions,
    })
  ),

  on(
    commonQuestionActions.setConsultBottomQuestionsAction,
    (state, { bottomQuestions: consultBottomQuestions }) => ({
      ...state,
      consultBottomQuestions,
    })
  ),

  on(commonQuestionActions.setAllDefaultAction, () => commonQuestionIS)
);

export function commonQuestionReducer(
  state: CommonQuestionState,
  action: Action
): any {
  return commonQuestionRegister(state, action);
}
